import React, { useState } from 'react';
import { MultiSelect as Component } from 'primereact/multiselect';

function MultiSelect({
  selectedItem,
  onChange,
  options,
  placeholder,
  optionValue,
  optionLabel,
  label,
  name,
  disabled,
  filter = false,
  filterPlaceholder = 'Filter',
  showSelectAll = false,
  filterBy,
  maxSelectedLabels,
  ...rest
}) {
  return (
    <div>
      {label ? (
        <label
          htmlFor={name}
          className='block text-[11px] mb-2 font-bold text-sky-900'
        >
          {label}
        </label>
      ) : null}

      <Component
        value={selectedItem}
        onChange={onChange}
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        placeholder={placeholder}
        disabled={disabled}
        className='w-full text-xs border-none bg-gray-100 h-9'
        display='chip'
        filter={filter}
        filterPlaceholder={filterPlaceholder}
        showSelectAll={showSelectAll}
        filterBy={filterBy}
        maxSelectedLabels={maxSelectedLabels}
        {...rest}
      />
    </div>
  );
}

export default MultiSelect;
